module.exports = __webpack_public_path__ + "static/enterprise-2dc68e45ce96c422ec65e6f8ca6071b8.svg";